module.exports = __webpack_public_path__ + "img/pin_transport_red.ea52c7a3.svg";